const SortArrowIcon = ({ className, direction = null, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    focusable='false'
    height='11'
    role={title ? 'img' : undefined}
    style={{
      fill: '#424242',
      flexShrink: 0,
      opacity: direction ? 1 : 0.35,
      transform: direction === 'desc' ? 'rotate(180deg)' : undefined,
      transformOrigin: 'center',
      transition: 'transform 0.15s ease, opacity 0.15s ease'
    }}
    viewBox='0 0 11 11'
    width='11'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <polygon points='5.5,0.5 0.74,8.5 10.26,8.5' />
  </svg>
)

export default SortArrowIcon
